<template>
  <div class="flex-grow overflow-x-hidden scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-50">
    <div class="border-b border-gray-200 shadow-sm">
      <div class="flex px-2 lg:px-0 pt-3">
        <div class="ml-6 flex space-x-8">
          <SLink v-on:href-change="routeChanged" :currentRoute="currentRoute" href="/settings/facebook" activeClasses="border-indigo-500 text-gray-900" defaultClasses="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" class="p-5 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium duration-300 transition-all">{{ $t('settings.facebooks') }}</SLink>
          <SLink v-on:href-change="routeChanged" :currentRoute="currentRoute" href="/settings/whatsapp"  activeClasses="border-indigo-500 text-gray-900" defaultClasses="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" class="p-5 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium duration-300 transition-all">{{ $t('settings.whatsapp') }}</SLink>
          <SLink v-on:href-change="routeChanged" :currentRoute="currentRoute" href="/settings/canned"  activeClasses="border-indigo-500 text-gray-900" defaultClasses="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" class="p-5 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium duration-300 transition-all">{{ $t('settings.cannedMessages') }}</SLink>
          <SLink v-on:href-change="routeChanged" :currentRoute="currentRoute" href="/settings/autoresponders"  activeClasses="border-indigo-500 text-gray-900" defaultClasses="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" class="p-5 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium duration-300 transition-all">{{ $t('settings.autoresponders') }}</SLink>
          <SLink v-on:href-change="routeChanged" :currentRoute="currentRoute" href="/settings/flow"  activeClasses="border-indigo-500 text-gray-900" defaultClasses="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" class="p-5 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium duration-300 transition-all">{{ $t('flow.title') }}</SLink>
        </div>
      </div>
    </div>
    <component :is="SettingsComponent"></component>
  </div>
</template>

<script>
import SLink from '@/components/settings/SLink';
import NotFound from "./NotFound";
import Facebook from "./settings/FacebookPage";
import Whatsapp from "./settings/WhatsappPage";
import Autoresponders from "./settings/AutorespondersPage";
import Flow from "./settings/FlowPage";
import Canned from "./settings/CannedMessagesPage";


const routes = {
  '/': Facebook,
  '/facebook': Facebook,
  '/whatsapp': Whatsapp,
  '/autoresponders': Autoresponders,
  '/flow': Flow,
  '/canned': Canned,
}

export default {
  name: 'SettingsPage',
  components: { SLink },
  computed: {
    SettingsComponent () {
      let result = routes[this.SettingsInnerRoute];
      if (!result) {
        return NotFound;
      }
      if (typeof result === 'function') {
        return result(this.RouteArgs);
      } else {
        return result;
      }
    },
    SettingsInnerRoute() {
      let routeArgs = this.currentRoute.split('/');
      if (routeArgs[2]) {
        return `/${routeArgs[2]}`;
      } else {
        return '/';
      }
    },
    RouteArgs() {
      return this.currentRoute.split('/').slice(2);
    },
  },
  methods: {
    routeChanged(url) {
      this.currentRoute = url;
    }
  },
  data() {
    return {
      currentRoute: window.location.pathname,
    }
  },
}
</script>
